import ClientApi from "../../../api/modules/ClientApi"
import util from '../../../util'

const loadClientList = ({commit}, payload) =>{
  return new Promise((resolve, reject) => {

    const headers = util.getAuthHeader()

    payload.context.axios.get('api/clients', {headers}).then((response) => {

      commit('setClientList', response.data)

      resolve(response.data)

    }).catch(error => {

      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al cargar los clientes.')
        reject(error.response)
      }
      reject()

    });

  })

}

const loadClientById = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {

    const headers = util.getAuthHeader()

    payload.context.axios.get('api/clients/'+payload.clientId, {headers}).then((response) => {

      resolve(response.data)

    }).catch(error => {

      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al cargar el cliente.')
        reject(error.response)
      }
      reject()

    });

  })

}

const saveClient = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.post('api/clients',payload.client ,{headers}).then((response) => {

      resolve(response.data)

    }).catch(error => {

      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al registrar el cliente.')
        reject(error.response)
      }
      reject()

    });
  })
}

const editClient = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.put('api/clients',payload.client ,{headers}).then((response) => {

      resolve(response.data)

    }).catch(error => {

      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al actualizar el cliente.')
        reject(error.response)
      }
      reject()

    });

  })

}

const disableClient = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.patch('api/clients/'+payload.client.id+'/disable',{} ,{headers}).then((response) => {

      resolve(response.data)

    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al eliminar el usuario.')
        reject(error.response)
      }
      reject()

    })
  })
}

//ACCIONES PARA USUARIOS DEL CLIENTE

const loadUserClientList = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {

    const headers = util.getAuthHeader()

    payload.context.axios.get('api/clients/'+payload.clientId+'/users', {headers})
      .then((response) => {

      resolve(response.data)

    })
      .catch(error => {

      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al cargar los usuarios del cliente.')
        reject(error.response)
      }
      reject()

    });

  })

}

const saveUserClient = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.post('api/clients/'+payload.clientId+'/users' , payload.user ,{headers})
      .then((response) => {

      resolve(response.data)

    })
      .catch(error => {

      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al registrar el usuario.')
        reject(error.response)
      }
      reject()

    });
  })
}

const editUserClient = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.put('api/clients/'+payload.clientId+'/users',payload.user ,{headers})
      .then((response) => {

      resolve(response.data)

    })
      .catch(error => {

      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al actualizar el usuario.')
        reject(error.response)
      }
      reject()

    });

  })

}

const enableUserClient = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.patch('api/clients/'+payload.clientId+'/users/'+payload.user.id+'/enable',{} ,{headers})
      .then((response) => {

      resolve(response.data)

    })
      .catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al activar el usuario.')
        reject(error.response)
      }
      reject()

    })
  })
}

const disableUserClient = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.patch('api/clients/'+payload.clientId+'/users/'+payload.user.id+'/disable',{} ,{headers})
      .then((response) => {

      resolve(response.data)

    })
      .catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al desactivar el usuario.')
        reject(error.response)
      }
      reject()

    })
  })
}

const restoreUserClientPass = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.patch('api/clients/'+payload.clientId+'/users/'+payload.user.id+'/restorepass',{} ,{headers})
      .then((response) => {

      resolve(response.data)

    })
      .catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al restablecer el usuario.')
        reject(error.response)
      }
      reject()

    })
  })
}

//ACCIONES PARA FILTROS DE BUSQUEDA
const updateSearchFields = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.put('api/clients/'+payload.clientId+'/searchFields',payload.filters ,{headers})
      .then((response) => {

      resolve(response.data)

    })
      .catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al actualizar los filtros.')
        reject(error.response)
      }
      reject()

    })
  })
}

//ACCIONES PARA FILTROS DE BUSQUEDA
const updateSearchDefaultFields = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.put('api/clients/'+payload.clientId+'/searchDefaultFields',payload.filters ,{headers})
      .then((response) => {

      resolve(response.data)

    })
      .catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al actualizar los filtros.')
        reject(error.response)
      }
      reject()

    })
  })
}

//ACCIONES PARA TIPOS DE ARCHIVOS

const saveTypeFile = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.post('api/clients/'+payload.clientId+'/typefiles',payload.typeFile ,{headers})
      .then((response) => {

      resolve(response.data)

    })
      .catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al registrar el tipo.')
        reject(error.response)
      }
      reject()

    });

  })

}

const editTypeFile = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.put('api/clients/'+payload.clientId+'/typefiles',payload.typeFile ,{headers})
      .then((response) => {

      resolve(response.data)

    })
      .catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al actualizar el tipo.')
        reject(error.response)
      }
      reject()

    });

  })

}

const deleteTypeFile = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.delete('api/clients/'+payload.clientId+'/typefiles/'+payload.typefileId ,{headers})
      .then((response) => {
      resolve(response.data)

    })
      .catch(error => {
      if(error.response) {
        console.log(error)
        util.showDialogError(payload.context, 'Ocurrió un error al eliminar el tipo.')
        reject(error.response)
      }
      reject()

    });

  })

}


//ACCIONES PARA DIRECCIONES

const saveAddress = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.post('api/clients/'+payload.clientId+'/address',payload.address ,{headers})
      .then((response) => {

      resolve(response.data)

    })
      .catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al registrar la direccion.')
        reject(error.response)
      }
      reject()

    });

  })

}

const editAddress = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.put('api/clients/'+payload.clientId+'/address',payload.address ,{headers})
      .then((response) => {

      resolve(response.data)

    })
      .catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al actualizar la direccion.')
        reject(error.response)
      }
      reject()

    });

  })

}

const deleteAddress = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.delete('api/clients/'+payload.clientId+'/address/'+payload.addressId ,{headers})
      .then((response) => {
      resolve(response.data)

    }).catch(error => {
      if(error.response)
      {
        console.log(error)
        util.showDialogError(payload.context, 'Ocurrió un error al eliminar la direccion.')
        reject(error.response)
      }
      reject()

    });

  })

}

//ACCIONES PARA FACTURACION
const addChargeForCustody = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.post('api/clients/'+payload.clientId+'/custodyCharges',payload.charge ,{headers})
      .then((response) => {

      resolve(response.data)

    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al agregar el cargo por custodia.')
        reject(error.response)
      }
      reject()

    });

  })

}

const editChargeForCustody = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.put('api/clients/'+payload.clientId+'/custodyCharges',payload.charge ,{headers})
      .then((response) => {
      console.log(response.data)
      resolve(response.data)

    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al actualizar el cargo por custodia.')
        reject(error.response)
      }
      reject()

    });

  })

}

const deleteChargeForCustody = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.delete('api/clients/'+payload.clientId+'/custodyCharges/'+payload.uuid ,{headers})
      .then((response) => {
      resolve(response.data)

    }).catch(error => {
      if(error.response)
      {
        console.log(error)
        util.showDialogError(payload.context, 'Ocurrió un error al eliminar el cargo por custodia.')
        reject(error.response)
      }
      reject()

    });

  })

}

const addChargeForDigitalization = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.post('api/clients/'+payload.clientId+'/digitalizationCharges',payload.charge ,{headers})
      .then((response) => {

      resolve(response.data)

    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al agregar el cargo por Digitalization.')
        reject(error.response)
      }
      reject()

    });

  })

}

const editChargeForDigitalization = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.put('api/clients/'+payload.clientId+'/digitalizationCharges',payload.charge ,{headers})
      .then((response) => {

      resolve(response.data)

    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al actualizar el cargo por Digitalization.')
        reject(error.response)
      }
      reject()

    });

  })

}

const deleteChargeForDigitalization = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.delete('api/clients/'+payload.clientId+'/digitalizationCharges/'+payload.uuid ,{headers})
      .then((response) => {
      resolve(response.data)

    }).catch(error => {
      if(error.response)
      {
        console.log(error)
        util.showDialogError(payload.context, 'Ocurrió un error al eliminar el cargo por Digitalization.')
        reject(error.response)
      }
      reject()

    });

  })

}

//ACCIONES PARA HORARIO DE ATENCION
const updateBusinessHours = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.put('api/clients/'+payload.clientId+'/businessHours',payload.businessHours ,{headers})
      .then((response) => {

      resolve(response.data)

    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al actualizar los horarios.')
        reject(error.response)
      }
      reject()

    })
  })
}

//ACCIONES PARA CATEGORÍA

const saveCategory = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.post('api/clients/'+payload.clientId+'/categories',payload.category ,{headers})
      .then((response) => {

      resolve(response.data)

    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al registrar el tipo.')
        reject(error.response)
      }
      reject()

    });

  })

}

const editCategory = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.put('api/clients/'+payload.clientId+'/categories',payload.category ,{headers})
      .then((response) => {

      resolve(response.data)

    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al actualizar el tipo.')
        reject(error.response)
      }
      reject()

    });

  })

}

const deleteCategory = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.delete('api/clients/'+payload.clientId+'/categories/'+payload.categoryId ,{headers}).then((response) => {
      resolve(response.data)

    }).catch(error => {
      if(error.response)
      {
        console.log(error)
        util.showDialogError(payload.context, 'Ocurrió un error al eliminar el tipo.')
        reject(error.response)
      }
      reject()

    });

  })

}

const saveTransfers = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.put('api/clients/'+payload.clientId+'/transfers',payload.transfers ,{headers})
      .then((response) => {

      resolve(response.data)

    })
      .catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al grabar la configuración de translados.')
        reject(error.response)
      }
      reject()

    });

  })

}

const savePermisos = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.put(`api/clients/${payload.clientId}/permisos${payload.param}`,payload.access ,{headers})
      .then((response) => {

      resolve(response.data)

    })
      .catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al grabar la configuración de Permisos.')
        reject(error.response)
      }
      reject()

    });

  })

}

const saveMaterial = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.post('api/clients/'+payload.clientId+'/materiales',payload.material ,{headers})
      .then((response) => {

      resolve(response.data)

    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al registrar el tipo.')
        reject(error.response)
      }
      reject()

    });

  })

}

const editMaterial = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.put('api/clients/'+payload.clientId+'/materiales',payload.material ,{headers})
      .then((response) => {

      resolve(response.data)

    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al actualizar el tipo.')
        reject(error.response)
      }
      reject()

    });

  })

}

const deleteMaterial = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.delete('api/clients/'+payload.clientId+'/materiales/'+payload.idMaterial ,{headers}).then((response) => {
      resolve(response.data)

    }).catch(error => {
      if(error.response)
      {
        console.log(error)
        util.showDialogError(payload.context, 'Ocurrió un error al eliminar el tipo.')
        reject(error.response)
      }
      reject()

    });

  })

}

const saveArea = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.post('api/clients/'+payload.clientId+'/area',payload.area ,{headers})
      .then((response) => {

      resolve(response.data)

    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al registrar el área.')
        reject(error.response)
      }
      reject()

    });

  })

}

const editArea = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.put('api/clients/'+payload.clientId+'/area',payload.area ,{headers})
      .then((response) => {

      resolve(response.data)

    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al actualizar el área.')
        reject(error.response)
      }
      reject()

    });

  })

}

const deleteArea = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.delete('api/clients/'+payload.clientId+'/area/'+payload.id ,{headers}).then((response) => {
      resolve(response.data)

    }).catch(error => {
      if(error.response)
      {
        console.log(error)
        util.showDialogError(payload.context, 'Ocurrió un error al eliminar el área.')
        reject(error.response)
      }
      reject()

    });

  })

}

const exportUserToFile = ({commit}, payload) => {
  const extensions = {
    'pdf': 'pdf',
    'excel': 'xlsx'
  }

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader();

    payload.context.axios.get(`api/clients/${payload.clientId}/users/export`, {
        headers: { ...headers, responseType: 'blob'},
        params: { format: payload.format},
        responseType: 'blob'
      })
      .then(response => {
        const urlArchivo = URL.createObjectURL(response.data);

        const enlace = document.createElement('a');
        enlace.href = urlArchivo;
        enlace.download = `reporte-usuarios.${extensions[payload.format]}`;
        document.body.appendChild(enlace);
        enlace.click();
      })
      .catch(error => {
        if (error.response) {
          util.showDialogError(payload.context, "Ocurrió un error al descargar el archivo")

          reject(error.response)
        }
        else reject(error)
      })
  })
}

const getAreasByClient = async ({ commit }, payload) => {
  try {
    const { context, clientId } = payload;
    return await ClientApi.getAreasByClient(context, clientId);
  } catch (error) {
    console.error("Error al obtener áreas del cliente:", error);
    throw error;
  }
};

export default {
  loadClientList,
  saveClient,
  editClient,
  disableClient,
  loadClientById,

  //ACCIONES PARA USUARIOS DEL CLIENTE
  loadUserClientList,
  saveUserClient,
  editUserClient,
  enableUserClient,
  disableUserClient,
  restoreUserClientPass,
  exportUserToFile,


  //ACCIONES PARA FILTROS DE BUSQUEDA
  updateSearchFields,
  updateSearchDefaultFields,

  //ACCIONES PARA TIPOS DE ARCHIVOS
  saveTypeFile,
  editTypeFile,
  deleteTypeFile,

  //FACTURACION
  addChargeForCustody,
  editChargeForCustody,
  deleteChargeForCustody,
  addChargeForDigitalization,
  editChargeForDigitalization,
  deleteChargeForDigitalization,


  //ACCIONES PARA DIRECCIONES
  saveAddress,
  editAddress,
  deleteAddress,

  //HORARIOS DE ATENCION
  updateBusinessHours,

  //CATEGORÍAS
  saveCategory,
  editCategory,
  deleteCategory,

  //TRANSLADOS
  saveTransfers,

  //PERMISOS
  savePermisos,

  //MMATERIALES
  saveMaterial,
  editMaterial,
  deleteMaterial,

  //AREAS
  getAreasByClient,
  saveArea,
  editArea,
  deleteArea

};






// WEBPACK FOOTER //
// ./src/store/modules/client/actions.js